import { render, staticRenderFns } from "./ScanInfoEdit.vue?vue&type=template&id=490578ff&scoped=true"
import script from "./ScanInfoEdit.vue?vue&type=script&lang=js"
export * from "./ScanInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./ScanInfoEdit.vue?vue&type=style&index=0&id=490578ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490578ff",
  null
  
)

export default component.exports